// NOTE: hooks
import { ReactNode, useEffect } from 'react'
import useDataAuth from './useDataAuth'
// NOTE: components
import Container from '../../components/ui/Container'
import Loading from '../../components/ui/Loading'
import Offline from '../../pages/Oflline'
import Register from './Register'
import Login from './Login'
import SetPwd from './SetPwd'
import ResetPwd from './ResetPwd'
// NOTE: images
import TWDRectangle from '../../assets/img/logo/helfyTWD.png'
import staffMockup from '../../assets/img/analyticsMockup.png'

const Auth = () => {
	const {
		loading,
		display,
		route,
		online,
		shouldRedirect,
		handleRegisterDisplay,
		handleLoginDisplay,
		handlePasswordDisplay,
		redirectAuthenticatedUser,
		refresh
	} = useDataAuth()

	useEffect(() => {
		if (shouldRedirect) redirectAuthenticatedUser()
		}, [shouldRedirect, redirectAuthenticatedUser])
	
	if (loading) return <Loading />
	return (
		<>
			<div className={`min-h-screen ${online ? 'hidden' : 'block'}`}>
				<Offline refresh={refresh} />
			</div>
			<div className={`${online ? 'flex' : 'hidden'} min-v-svh min-h-screen`}>
				<div className="hidden w-1/3 p-0 lg:flex">
					<img src={staffMockup} alt="helfy app" className="my-auto ml-auto max-h-[80vh] pl-12" />
				</div>
				<Container className="mx-auto !max-w-[650px]">
					<div className="my-12 flex">
						<img
							src={TWDRectangle}
							style={{ width: '65%', maxWidth: 300 }}
							className="mx-auto"
							alt="helfy by The Wellbeing Doctors"
						/>
					</div>
					<div>
						{display === 'SET_PASSWORD' && (
							<AuthForm
								hideAlternativeAction={route === 'admin'}
								alternativeDescription="Remembered your password?"
								alternativeTitle="Sign in"
								alternativeAction={handleLoginDisplay}
							>
								<SetPwd />
							</AuthForm>
						)}
						{display === 'RESET_PASSWORD' && (
							<AuthForm
								alternativeDescription="Go back to login page?"
								alternativeTitle="Sign in"
								alternativeAction={handleLoginDisplay}
							>
								<ResetPwd />
							</AuthForm>
						)}
						{display === 'LOGIN' && (
							<AuthForm
								hideAlternativeAction={route === 'admin'}
								alternativeDescription="New here?"
								alternativeTitle="Create Account"
								alternativeAction={handleRegisterDisplay}
							>
								<Login handlePasswordDisplay={handlePasswordDisplay} />
							</AuthForm>
						)}
						{display === 'REGISTER' && (
							<AuthForm
								alternativeDescription="Already have an account?"
								alternativeTitle="Login"
								alternativeAction={handleLoginDisplay}
							>
								<Register />
							</AuthForm>
						)}
					</div>
				</Container>
			</div>
		</>
	)
}

interface AuthFormProps {
	alternativeDescription: string,
	alternativeTitle: string,
	alternativeAction: any,
	hideAlternativeAction?: any,
	children: ReactNode
}

const AuthForm = ({
	alternativeDescription,
	alternativeTitle,
	alternativeAction,
	hideAlternativeAction,
	children
}: AuthFormProps) => {
	return (
		<div className="pb-5">
			{!hideAlternativeAction && (
				<div className="mb-12 text-center font-semibold">
					<p className="text-dark">
						{alternativeDescription}
						<button
							className="ml-2 font-bold text-orange-600 underline hover:text-orange-600"
							onClick={alternativeAction}
						>
							{alternativeTitle}
						</button>
					</p>
				</div>
			)}

			<div className="md:rounded-lg md:bg-white md:px-10 md:pb-10 md:pt-8 md:shadow">
				{children}
			</div>
		</div>
	)
}

export default Auth
